/* eslint-disable @typescript-eslint/no-explicit-any */
import { CMSAliasViewModel } from '../view-models/content/cms-alias.viewModel';
import { CMSBlocksPageContentViewModel } from '../view-models/content/cms-blocks-page-content.viewModel';
import { CMSMenuViewModel } from '../view-models/content/cms-menu-view-model/cms-menu.viewModel';

import type { CMSContentType } from '../../domain/types/cms-content.types';
import type { CMSContentViewModel } from '../types/cms-content.viewModel';

const cmsContentPresentersMap = {
  alias: CMSAliasViewModel.presenter,
  menu: CMSMenuViewModel.presenter,
  blocksPage: CMSBlocksPageContentViewModel.presenter
} as const satisfies Record<CMSContentType, (entity: any) => CMSContentViewModel>;

// TODO: remove
export function cmsContentPresenter<T extends { $type: string }>(entity: T) {
  return cmsContentPresentersMap[entity.$type as CMSContentType](entity as any);
}
